import { Box, Divider, LinearProgress, SxProps, Theme } from "@mui/material";
import React, { isValidElement } from "react";
import { KeyDriveBodyMin } from "../../../components/KeydriveComponents/Fonts/Body/KeyDriveBodyMin";
import { KeyDriveh4Header } from "../../../components/KeydriveComponents/Fonts/Headers/KeyDriveh4Header";
import { Workspaces } from "@mui/icons-material";
import { t } from "i18next";

interface IAdminConsoleHeader {
    iconTitle: React.ReactNode;
    title: string;
    subtitle: string;
    isLoading?: boolean;
}

export const AdminConsoleHeader: React.FC<IAdminConsoleHeader> = ({
    iconTitle,
    title,
    subtitle,
    isLoading
}) => {

    // estilo padrão do ícone/título
    const defaultIconStyle: SxProps<Theme> = {
        color: "#22638D",
        alignSelf: 'self-end',
        width: '27px',
        height: '27px',
    };

    // se o iconTitle for um elemento React com prop `sx`, mescla os estilos
    const styledIconTitle = isValidElement(iconTitle)
        ? React.cloneElement(iconTitle as any, {
            sx: { ...defaultIconStyle, ...(iconTitle.props?.sx || {}) },
            width: iconTitle.props?.width ?? '24px',
            height: iconTitle.props?.height ?? '24px',
        })
        : iconTitle;

    return (
            <Box sx={{
                display: "flex",
                flexDirection: "column",
                gap: '20px',
            }}>
                <Box sx={{
                    display: 'flex',
                    flexDirection: "row",
                    gap: '12px',
                }}>
                    {styledIconTitle}
                    {<KeyDriveh4Header
                                color="#2D2D2D"
                                needEllipses={false}
                                text={title}
                                sxStyles={{font: 'normal normal 600 20px/27px Segoe UI'}}
                                needBold
                            /> }
                </Box>
                { subtitle != "" && (
                    <Box>
                        <KeyDriveBodyMin
                            needEllipses={false}
                            color="#969696"
                            text={subtitle}
                            needBold={false}
                        />
                    </Box>
                ) }
                {!isLoading ? <Divider /> : <LinearProgress />}
            </Box>
    )
}